import { datetimeFormatter } from "@validereinc/utilities";
import isValid from "date-fns/isValid";
import parseISO from "date-fns/parseISO";

/**
 * Formats JSON-like record values for UI: booleans as Yes/No, valid `Date` instances
 * and ISO date-time strings via {@link datetimeFormatter}, arrays as comma-separated
 * recursively formatted items, plain objects as `JSON.stringify`, and other primitives
 * as strings. `null` and `undefined` yield an empty string.
 */
export const formatUnknownRecordValueForDisplay = (value: unknown): string => {
  if (value == null) {
    return "";
  }
  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }
  if (Array.isArray(value)) {
    return value
      .map((item) => formatUnknownRecordValueForDisplay(item))
      .join(", ");
  }
  if (value instanceof Date) {
    return isValid(value) ? datetimeFormatter(value) : "";
  }
  if (typeof value === "string" && value.trim() !== "") {
    const parsed = parseISO(value);
    if (isValid(parsed)) {
      return datetimeFormatter(parsed);
    }
  }
  if (typeof value === "object") {
    return JSON.stringify(value);
  }
  return String(value);
};
